import {$window, $body} from '../Constants';
import HtmlElementsStack from '../Elements/HtmlElementsStack';

// import special HtmlElements
import Banner from '../Elements/Banner';
import Header from '../Elements/Header';
import HorizontalSubMenu from '../Elements/HorizontalSubMenu';
import BackToTopButton from '../Elements/BackToTopButton';
import ContentSlider from '../Elements/ContentSlider';
import ImageSlider from '../Elements/ImageSlider';
import Videos from '../Elements/Videos';

/**
 * Controller for this page
 * Handles page flow and special HtmlElements
 */
class PageController {

    constructor() {
        // Object containing special elements that inherit from HtmlElement
        // relevant page events are delegated to these objects through the controller
        this.htmlElementsStack = new HtmlElementsStack(
            Banner,
            Header,
            HorizontalSubMenu,
            BackToTopButton,
            ContentSlider,
            ImageSlider,
            Videos
        );

        this.formatHeadlines();
    }

    onReady() {
        // pass ready event to HtmlElements
        this.onEvent('onReady');

        this.bindEventListeners();
        this.setBoxesEqualizer();
    }

    onEvent(fn, e = {}) {
        // pass event to HtmlElements
        this.htmlElementsStack.forEachCallFunction(fn, e);
    }

    bindEventListeners() {
        $window.on({
            'load': e => {this.onEvent('onLoad', e)},
            'scroll': e => {this.onEvent('onScroll', e)},
            'resize': e => {this.onEvent('onResize', e)},
        });
    }

    setBoxesEqualizer() {
        let $rows = $('.row.equalized'),
            boxPadding = 30;

        $rows.each(function() {
            let $columns = $(this).find('.columns.equalize'),
                $row = $(this);

            $columns.each(function() {
                let $boxes = $(this).find('> .box');

                if($boxes.length == 1) {
                    $boxes.css('height', '100%');
                }else if($boxes.length > 1) {
                    $row.foundation('getHeights', function(heights) {
                        let height = Math.max(...heights) / $boxes.length - boxPadding * ($boxes.length - 1);
                        $boxes.css('min-height', height);
                    });

                    new Foundation.Equalizer($row).applyHeight();
                }
            });
        });
    }

    formatHeadlines() {
        $body.find('h1').each(function() {
            if($(this).next('h2').length > 0) {
                $(this).addClass('h2Next');
            }else {
                $(this).addClass('h2NotNext');
            }
        });

        $body.find('h2').each(function() {
            if($(this).next('h3').length > 0) {
                $(this).addClass('h3Next');
            }else {
                $(this).addClass('h3NotNext');
            }
        });
    }
}

export default (new PageController);